import { Component, ReactNode, ErrorInfo } from 'react';
import { Card, Text, Button } from '@fluentui/react-components';

interface ErrorBoundaryProps {
  children?: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error?: Error;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  public state: ErrorBoundaryState = {
    hasError: false,
  };

  public static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught application error:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            padding: '24px',
            background: 'linear-gradient(135deg, #fff5f5 0%, #fef0f0 40%, #f5f0ff 100%)',
          }}
        >
          <Card
            style={{
              maxWidth: '480px',
              width: '100%',
              padding: '40px',
              borderRadius: '16px',
              boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
              border: 'none',
              textAlign: 'center',
            }}
          >
            <div
              style={{
                width: '56px',
                height: '56px',
                borderRadius: '14px',
                backgroundColor: '#fde7e9',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 20px',
                fontSize: '28px',
              }}
            >
              !
            </div>
            <Text
              style={{ fontSize: '20px', fontWeight: 700, color: '#242424', display: 'block', marginBottom: '8px' }}
            >
              Something went wrong
            </Text>
            <Text
              style={{ fontSize: '14px', color: '#616161', display: 'block', marginBottom: '20px', lineHeight: '20px' }}
            >
              An unexpected error occurred. Please try reloading the page.
            </Text>
            {this.state.error && (
              <pre
                style={{
                  background: '#f5f5f5',
                  padding: '12px 16px',
                  borderRadius: '8px',
                  overflowX: 'auto',
                  fontSize: '12px',
                  marginBottom: '24px',
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word',
                  textAlign: 'left',
                  color: '#a4262c',
                  fontFamily: "'Cascadia Code', Consolas, monospace",
                }}
              >
                {this.state.error.message}
              </pre>
            )}
            <Button
              appearance="primary"
              onClick={() => window.location.reload()}
              style={{ width: '100%', height: '40px', borderRadius: '8px' }}
            >
              Reload Application
            </Button>
          </Card>
        </div>
      );
    }

    return this.props.children;
  }
}
